module.exports = __webpack_public_path__ + "img/t3-salmon.76290639.png";